module.exports = __webpack_public_path__ + "img/big.4113ec19.jpg";